import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './LandingLegalPage.css';
import messages from '../../locale/messages';
import { legalRichTextValues } from './legalMessageValues';
import LandingLegalPage from './LandingLegalPage';

const helpFaqs = [
  {
    question: messages.newLandingLegalHelpFaq1Question,
    answer: messages.newLandingLegalHelpFaq1Answer,
  },
  {
    question: messages.newLandingLegalHelpFaq2Question,
    answer: messages.newLandingLegalHelpFaq2Answer,
  },
  {
    question: messages.newLandingLegalHelpFaq3Question,
    answer: messages.newLandingLegalHelpFaq3Answer,
  },
  {
    question: messages.newLandingLegalHelpFaq4Question,
    answer: messages.newLandingLegalHelpFaq4Answer,
  },
  {
    question: messages.newLandingLegalHelpFaq5Question,
    answer: messages.newLandingLegalHelpFaq5Answer,
  },
  {
    question: messages.newLandingLegalHelpFaq6Question,
    answer: messages.newLandingLegalHelpFaq6Answer,
  },
  {
    question: messages.newLandingLegalHelpFaq7Question,
    answer: messages.newLandingLegalHelpFaq7Answer,
  },
  {
    question: messages.newLandingLegalHelpFaq8Question,
    answer: messages.newLandingLegalHelpFaq8Answer,
  },
];

class LandingHelp extends React.Component {
  render() {
    return (
      <LandingLegalPage
        activePage="help"
        pageTitleMessage={messages.batch2HelpH1}
      >
        <section className={s.legalSection}>
          <h2><FormattedMessage {...messages.newLandingLegalHelpHeading} /></h2>
          <p><FormattedMessage {...messages.newLandingLegalHelpIntro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalHelpFaqHeading} /></h3>

          {helpFaqs.map(({ question, answer }) => (
            <React.Fragment key={question.id}>
              <strong><FormattedMessage {...question} /></strong>
              <p><FormattedMessage {...answer} /></p>
            </React.Fragment>
          ))}

          <h3><FormattedMessage {...messages.newLandingLegalHelpGuidesHeading} /></h3>

          <strong><FormattedMessage {...messages.newLandingLegalHelpGuideListTitle} /></strong>
          <ol>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideListStep1} /></li>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideListStep2} /></li>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideListStep3} /></li>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideListStep4} /></li>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideListStep5} /></li>
          </ol>

          <strong><FormattedMessage {...messages.newLandingLegalHelpGuideBookTitle} /></strong>
          <ol>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideBookStep1} /></li>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideBookStep2} /></li>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideBookStep3} /></li>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideBookStep4} /></li>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideBookStep5} /></li>
          </ol>

          <strong><FormattedMessage {...messages.newLandingLegalHelpGuideManageTitle} /></strong>
          <ol>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideManageStep1} /></li>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideManageStep2} /></li>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideManageStep3} /></li>
            <li><FormattedMessage {...messages.newLandingLegalHelpGuideManageStep4} /></li>
          </ol>

          <h3><FormattedMessage {...messages.newLandingLegalHelpContactHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalHelpContactIntro} /></p>
          <ul>
            <li>
              <FormattedMessage
                {...messages.newLandingLegalHelpContactEmail}
                values={legalRichTextValues}
              />
            </li>
            <li>
              <FormattedMessage
                {...messages.newLandingLegalHelpContactChat}
                values={legalRichTextValues}
              />
            </li>
          </ul>
          <p><FormattedMessage {...messages.newLandingLegalHelpContactOutro1} /></p>
          <p><FormattedMessage {...messages.newLandingLegalHelpContactOutro2} /></p>
        </section>
      </LandingLegalPage>
    );
  }
}

export default withStyles(s)(LandingHelp);
